import { Controller } from "stimulus";
import { initAvatarField, initResumeField } from "../utils";

export default class extends Controller {
  uppys = []

  connect() {
    document.querySelectorAll('.avatar-field-wrapper').forEach((avatarFieldWrapper) => {
      const avatarField = avatarFieldWrapper.querySelector('.avatar-field')
      const avatarFieldResult = avatarFieldWrapper.querySelector('.avatar-field-result')
      if (avatarField) {
        const uppy = initAvatarField(avatarField, avatarFieldResult)
        this.uppys.push(uppy)
      }
    })

    document.querySelectorAll('.resume-field-wrapper').forEach((resumeFieldWrapper) => {
      const resumeField = resumeFieldWrapper.querySelector('.resume-field')
      const resumeFieldResult = resumeFieldWrapper.querySelector('.resume-field-result')
      if (resumeField) {
        const uppy = initResumeField(resumeField, resumeFieldResult)
        this.uppys.push(uppy)
        
        // Auto reset destroy flag when file is uploaded
        const destroyInput = resumeFieldWrapper.querySelector('input[name$="[_destroy]"]')
        if (destroyInput) {
          // Set destroy flag to false when file is added
          uppy.on('file-added', () => {
            destroyInput.value = "false"
          })

          // Set destroy flag to true when file is removed
          uppy.on('file-removed', () => {
            destroyInput.value = "true"
          })

          // Listen for change event on destroyInput
          destroyInput.addEventListener('change', (e) => {
            // Remove file upload if value is false
            if(destroyInput.value === "false") {
              const files = uppy.getFiles();
              files.forEach((file) => {
                uppy.removeFile(file.id);
              })
              destroyInput.value = "false"
            }
          })
        }
      }
    })
  }

  submit(e) {
    e.preventDefault()
    if (window.uppyInstances && window.uppyInstances.length > 0) {
      this.uppys = (this.uppys || []).concat(window.uppyInstances)
    }

    const promises = this.uppys.map((_uppy) => _uppy.upload())
    Promise.all(promises).then((result) => {
      // Clear to avoid duplicate uploads on next submit
      window.uppyInstances = []
      e.target.submit()
    })
  }
}
